import React, { useEffect, useState } from "react";
import { AdCampaign } from "components/AdCampaign/AdCampaign";
import { InsightsSidebarArticleSection } from "./InsightsSidebarArticleSection";
import styles from "./InsightsSidebar.module.scss";
import classNames from "classnames";

type Props = {
  tickerSymbol?: string;
  excludeInsightId?: string;
  relatedInsightIds?: string[];
  authorName?: string;
};

export const InsightsSidebar: React.FC<Props> = (props) => {
  const [excludedInsightId, setExcludedInsightId] = useState<string>(
    props.excludeInsightId ?? ""
  );

  // Adding this state check / useEffect creates enough of a difference to temporarily
  // not display the insight section and re-render / reload data so they stay up to date
  useEffect(() => {
    if (excludedInsightId !== props.excludeInsightId) {
      setExcludedInsightId(props.excludeInsightId ?? "");
    }
  }, [props.excludeInsightId]);

  return (
    <div className={styles.insightsSidebar}>
      <div
        className={classNames(
          styles.insightsSidebar__container,
          styles.insightsSidebar__container_marginBottom
        )}
      >
        <AdCampaign size="md-rectangle" />
      </div>

      {(props.excludeInsightId === excludedInsightId ||
        !props.excludeInsightId) && (
        <InsightsSidebarArticleSection {...props} />
      )}

      <div className={styles.insightsSidebar__container}>
        <AdCampaign size="half-page" />
      </div>
    </div>
  );
};
